import React, { useRef, useEffect } from 'react'

import CarRentalSummaryCard from './CarRental'
import CruiseSummaryCard from './Cruise'
import TourSummaryCard from './Tour'

import { MapItem } from 'tripPlanner/types/tripItem'
import { assertUnreachable } from 'tripPlanner/utils'

export interface MapSummaryCardProps {
  item: MapItem
}

function MapSummaryCard({ item }: MapSummaryCardProps) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const element = ref.current
    if (element) {
      const onScroll = (e: WheelEvent) => e.preventDefault()
      element.addEventListener('wheel', onScroll)
      return () => element.removeEventListener('wheel', onScroll)
    }
  }, [])

  switch (item.type) {
    // These have been migrated to the new summary item / route cards
    case 'ACCOMMODATION':
    case 'EXPERIENCE':
    case 'ATTRACTION':
    case 'THING_TO_DO':
    case 'RESTAURANT_BAR':
    case 'EVENT':
    case 'FLIGHT':
    case 'BUS':
    case 'FERRY':
    case 'TRAIN':
    case 'OTHER_TRANSPORT':
      return null
    case 'CAR_RENTAL':
      return <CarRentalSummaryCard item={item} ref={ref} />
    case 'CRUISE':
      return <CruiseSummaryCard item={item} ref={ref} />
    case 'TOUR':
      return <TourSummaryCard item={item} ref={ref} />
    default:
      assertUnreachable(item)
  }
}

export default MapSummaryCard
